import { Component, EventEmitter, Input, Output, OnInit, signal } from '@angular/core';
import { CheckboxCustomEvent } from '@ionic/angular';
import {
  NPS_DETRACTOR_EMOJIS,
  NPS_EMOJI_OPTIONS,
  TNPS_EMOJI,
  TNPS_FEEDBACK_QUESTION,
  TNPS_USER_RESPONSE,
} from '@monorepo/types';

type TEmojiFeedbackView = {
  emojis: { isSelected: boolean; emoji: TNPS_EMOJI }[];
  options: { isSelected: boolean; value: string }[];
  isDetractorSelected: boolean;
  isAnyEmojiSelected: boolean;
};

@Component({
  selector: 'monorepo-nps-emoji-feedback',
  templateUrl: './nps-emoji-feedback.component.html',
  styleUrls: ['./nps-emoji-feedback.component.scss'],
})
export class NpsEmojiFeedbackComponent implements OnInit {
  @Input() feedbackQuestion: TNPS_FEEDBACK_QUESTION = {
    question: '',
    order_no: 1,
    answer_type: 'Emoji',
    detractor_questions: [],
    promoters_questions: [],
  };

  @Output() feedbackChange = new EventEmitter<Partial<TNPS_USER_RESPONSE>>();
  @Output() selectionMade = new EventEmitter<void>();

  view = signal<TEmojiFeedbackView>({
    emojis: [],
    options: [],
    isDetractorSelected: false,
    isAnyEmojiSelected: false,
  });

  ngOnInit(): void {
    this.view.update((v) => ({ ...v, emojis: NPS_EMOJI_OPTIONS.map((emoji) => ({ emoji, isSelected: false })) }));
  }

  selectEmoji(selectedEmoji: TEmojiFeedbackView['emojis'][number]['emoji']): void {
    if (!this.view().isAnyEmojiSelected) {
      this.selectionMade.emit();
    }
    const isDetractor = NPS_DETRACTOR_EMOJIS.includes(selectedEmoji);
    const availableOptions = isDetractor
      ? [...(this.feedbackQuestion.detractor_questions || [])]
      : [...(this.feedbackQuestion.promoters_questions || [])];

    this.view.update((v) => ({
      ...v,
      emojis: v.emojis.map((emojiItem) => ({
        ...emojiItem,
        isSelected: emojiItem.emoji === selectedEmoji,
      })),
      options: availableOptions.map((value) => ({ value, isSelected: false })),
      isDetractorSelected: isDetractor,
      isAnyEmojiSelected: true,
    }));
    this.emitFeedback();
  }

  onOptionChange(changedOption: TEmojiFeedbackView['options'][number], event: Event): void {
    const isChecked = (event as CheckboxCustomEvent).detail.checked;
    this.view.update((v) => ({
      ...v,
      options: v.options.map((option) =>
        option.value === changedOption.value ? { ...option, isSelected: isChecked } : option,
      ),
    }));
    this.emitFeedback();
  }

  emitFeedback(): void {
    const selectedEmoji = this.view().emojis.find((e) => e.isSelected)?.emoji;
    if (selectedEmoji) {
      this.feedbackChange.emit({
        answer: selectedEmoji,
        selected_options: this.view()
          .options.filter((o) => o.isSelected)
          .map((o) => o.value),
      });
    }
  }
}
